import React, {useState,useEffect,useReducer} from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import SimpleReactValidator from 'simple-react-validator';
import logo from '../images/logo.png';
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import ContainerImage from '../images/2.jpg';
import { useNavigate } from "react-router-dom";
import { FadeLoader } from 'react-spinners';
const eye = <FontAwesomeIcon icon={faEye} />;

var api = require('../Common/Config');
var  RESEND_OTP = 'anonymous/resendOTPFormAPI?userId=';
var  SEND_OTP='anonymous/sendOTPFormAPI?userId=';
var  USER_REGISTER = 'anonymous/user';
var  SECRET_QUESTIONS = 'anonymous/getUserSecretCategory';


function CreateNewUser () {
    const [validator,setValidator] = useState(new SimpleReactValidator());
    const [Questions,setQuestions] = useState([]);
    const [SecurityQues,setSecurityQues] = useState("");
    const [Username,setUsername] = useState("");
    const [NationalID,setNationalID] = useState("");
    const [Fname,setFname] = useState("");
    const [Lname,setLname] = useState("");
    const [PassWord,setPassWord] = useState("");
    const [ReTypePassWord,setReTypePassWord] = useState("");
    const [EnteredOTP,setEnteredOTP] = useState("");
    const [OtpReference,setOtpReference] = useState("");
    const [SecurityAns,setSecurityAns] = useState("");
    const [AddressLine1,setAddressLine1] = useState("");
    const [AddressLine2,setAddressLine2] = useState("");
    const [AddressLine3,setAddressLine3] = useState("");
    const [Email,setEmail] = useState("");
    const [PhoneNumber,setPhoneNumber] = useState("");
    const [ConfirmOTP,setConfirmOTP] = useState("");
    const [SentMobile,setSentMobile] = useState("");
    const [FailMessge,setFailMessge] = useState("");
    const [ErrorMsg,setErrorMsg] = useState("");
    const [ErrorAlert,setErrorAlert] = useState(false);
    const [Successpop,setSuccesspop] = useState("");
    const [Unsuccesspop,setUnsuccesspop] = useState("");
    const [Trials,setTrials] = useState("");
    const [Invalid, setInvalid] =useState("");
    const [Expire, setExpire] =useState("");
    const [UserExist, setUserExist] =useState("");
    const [UserNICExist, setUserNICExist] =useState("");
    const [ShowPassword, setShowPassword] =useState(false);
    const [ShowPassword2, setShowPassword2] =useState(false);
    const [idType, setIDType] = useState("NIC");
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const navigate = useNavigate();
    let passportValidate = /^(?!^0+$)[a-zA-Z0-9]{3,20}$/gm;

    const SecurityQuestion=(event)=>{
        var passValFrom = JSON.parse(event.target.value);
        setSecurityQues(JSON.parse(event.target.value));
    }

    const handleIDType = (event) => {
        setIDType(event.target.value);
    }
    
    const fetchQuestion = async()=>{
        await axios({
        url:api.HOST+SECRET_QUESTIONS,
        method: "GET",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      })
      .then((result) => {
          setQuestions(result.data);            
          
      }).catch((error)=> {
        console.log(error);
    })
  };
    useEffect( () => {
       
    fetchQuestion();
    },[]);

    const SendOTP = async () => {
        if (!validator.allValid()) {
            console.log('validator.errorMessages', validator.errorMessages)
            if(idType == 'BRG' && validator.fieldValid('Business Name') && Lname != ''){
                if(PassWord!=ReTypePassWord || (idType == "NIC" && NICValidate.test(NationalID) == false)||!PassWord.match(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)/) || (idType == "PAS" && passportValidate.test(NationalID) == false)){
                    setErrorAlert(true);
                }else{
                    OTPRequest();
                }
                return false;
            }
            validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`            
            forceUpdate();            
          }else if(PassWord!=ReTypePassWord || (idType == "NIC" && NICValidate.test(NationalID) == false)||!PassWord.match(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)/) || (idType == "PAS" && passportValidate.test(NationalID) == false)){
            setErrorAlert(true)
          } else {  
            OTPRequest();
          }
      }

    const OTPRequest = async() => {
        setLoading(true);
        return await axios({
            url:api.HOST+SEND_OTP+Username.trim().toLowerCase()+'&clientId='+NationalID+'&idType='+idType,
            method: "GET",
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          }) .then((result) => {
              if(result?.response?.status == 400 && result?.response?.data?.status == 'error'){
                  setErrorMsg(result.response.data.description);
                  setErrorAlert(true);
                  setLoading(false);
                  return false;
              }
              setOtpReference(result.data.otpRef);                
              if(result.data.otpRef){
                  setConfirmOTP(true);                  
              }else{
                  setErrorMsg(result.data.description);
                  setErrorAlert(true)
              }
            setLoading(false);
            return result;
          }).catch((error)=> {
            setLoading(false);
            console.log(error);              
            setErrorMsg(error.response.data.description);
            setErrorAlert(true)
        });
    }

    const  ResendOTP = async ()=> {
      
          return await axios({
            url:api.HOST+RESEND_OTP+Username.trim().toLowerCase()+'&clientId='+NationalID+'&otpRef='+OtpReference+'&idType='+idType, 
            method: "GET",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          })
          .then((result) => {
              setOtpReference(result.data.otpRef)
                //dataSource: result.fdList,
              return result;
          }).catch((error)=> {           
            console.log(error.response.data.description);
            
            setFailMessge(error.response.data.description);
        })
        
      }

    const UserRegister= async ()=> {
        setErrorMsg("");
        setDisabled(true);
        return await axios({        
        method: "post",
        url:api.HOST+USER_REGISTER, 
        headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                 },
        data: JSON.stringify({
                "userId": Username.trim().toLowerCase(),
                "idNumber": NationalID,
                "firstName": Fname,
                "lastName": Lname,
                "password": PassWord,
                "twoFAEnabled": false,
                "twoFANotficationMode": "EML",
                "active": false,
                "otpCode":EnteredOTP,
                "otpRef":OtpReference,
                "userSecretCatCode":SecurityQues,
                "securityAns":SecurityAns,
                "addressLine1":AddressLine1,
                "addressLine2":AddressLine2,
                "locality":AddressLine3,
                "email":Email,
                "phoneNo":PhoneNumber,
                'idType':idType,
            }),
          }).then((result) => {
              if(result.data.status==="SUCCESS"){
                  setConfirmOTP(false);
                  setSuccesspop(true);               
              }else if(result.data.status==="UNSUCCESS"){
                  setUnsuccesspop(true);
                  setErrorAlert(true);                
              }else if(result.data.status==="TRIALS"){
                  setTrials(true);    
                  setErrorAlert(true) ;           
              }else if(result.data.status==="INVALID"){
                  setInvalid(true); 
                  setErrorAlert(true) ;             
              }else if(result.data.status==="EXPIRY"){
                  setExpire(true); 
                  setErrorAlert(true) ;                
              }else if(result.data.status==="USER_EXIST"){
                  setUserExist(true);  
                  setErrorAlert(true) ;               
              }else if(result.data.status==="NIC_EXIST"){
                setUserNICExist(true); 
                setErrorAlert(true) ;                
              }
              setDisabled(false);
              return result;
          }).catch((error)=> {
             setDisabled(false);
            console.log(error);
        });
    }

    const ResponseLoadingModal = ()=> {
        return(
            <Modal
            size="lg"
            centered 
            className="ui-block" show={loading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={loading}
                />
           
           </Modal>
         )
      }

    const OTPModal =  () =>{
        return(
        <Modal  
            show={ConfirmOTP}             
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered 
            backdrop="static"
            onHide={() =>{setConfirmOTP(false); setFailMessge("")}}
            >
            <Modal.Header closeButton>
                <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                <p className='modal-head-f'>OTP</p><br/> CONFIRMATION
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            
            <p className='form-h3 form-h2'>We have sent you a OTP code . Please enter it below.</p>
            <Form className="text-center" onSubmit={e => e.preventDefault()}>
                <div className="form-group">
                <Form.Control type="text"
                 onChange={(e)=>setEnteredOTP(e.target.value)}
                 placeholder="OTP Code" /> 
                <p className="error-text2">{FailMessge} </p>                      
                </div>                        
                <div className="d-flex justify-content-end">                        
                <Button type="button" onClick ={()=>ResendOTP()}className="btn-logout"  >Resend OTP</Button>
                <Button type="button" disabled={disabled} onClick ={()=>UserRegister()} className="btn-logout " >Confirm</Button>
                </div>
            </Form>                                   
            </Modal.Body>
            </Modal>
        );
    }
    
    let NICValidate =/^([0-9]{9}[X|V]|[0-9]{12})$/m;

    const hsetShowPassword = () =>{
        setShowPassword(true)
        setTimeout(() => {
            setShowPassword(false)
          }, 900);
    }
    const hsetShowPassword2 = () =>{
        setShowPassword2(true)
        setTimeout(() => {
            setShowPassword2(false)
          }, 900);
    }
    // document.getElementById("fill").reset();
        return(
            <Container fluid className="body-register">    
                <Container >
                    {OTPModal()}
                    {ResponseLoadingModal()}
                    <Row> 
                    { Successpop?
                    <SweetAlert success btnSize='lg' confirmBtnBsStyle='success'
                     title="SUCCESSFUL" onConfirm={()=> {setSuccesspop(false); navigate('/');}}>
                      User Registered Successfully
                    </SweetAlert>:null
                    }
                   { ErrorAlert? 
                   <SweetAlert warning btnSize='lg' confirmBtnBsStyle='success' title="Error" onConfirm={()=> setErrorAlert(false)} >
                    {PassWord!=ReTypePassWord?
                    "Password does not Match with Re-type password"
                    :(idType == "NIC" && NICValidate.test(NationalID) == false)?
                    "Entered NIC is Incorrect Or Letter 'V' or 'X' should Capital"
                    :(idType == "PAS" && passportValidate.test(NationalID) == false)?
                    'Invalid Passport Number'
                    :!PassWord.match(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)/)?
                    <div>
                    Please note that Passwords are case sensitive
                    password should contain 8 characters with at least 1 digit and 1 letter"
                    </div>
                    :ErrorMsg?
                    <div> {ErrorMsg}</div>                   
                    : Unsuccesspop?
                    <div>
                        Contact <br/>
                        Phone: +94 112 301301<br/>
                        Email: senk@senfin.com <br/> 
                        267, Galle Road, Colombo 03, Sri Lanka
                    </div>
                    : Trials?  
                    <div>
                        Trial more than three times<br/>
                        Contact <br/>
                        Phone: +94 112 301301<br/>
                        Email: senk@senfin.com<br/> 
                        267, Galle Road, Colombo 03, Sri Lanka
                    </div>
                    : Invalid?  
                    "Enter Correct OTP"                
                    : Expire?  
                    "Expired OTP. Try With Resend OTP"
                    : UserExist?
                    "Username Exist, Try With New Username"
                    : UserNICExist?
                    "Your NIC already Registered"
                    :null               
                    }   
                    </SweetAlert> :null 
                     }

                    <Row>
                        <Col lg={4}>
                        <div className="login-area block-top bottoms ">
                            <img className='logo' alt="Senfin" src={logo} />
                            <div>
                            <h3>SENFIN ONLINE PORTAL </h3>   
                            <p className='small-font-log'>MAKE YOUR DIGITAL TRANSACTIONS THE SIMPLE WAY</p>                     
                            </div>                        
                        </div>
                        </Col>               
                    </Row>
                    <Row className='flex-row-center mt-4'>
                    <Col lg={10} sm={12}>
                    <div className="main-wrap2 animate__animated animate__fadeIn animate__faster">
                    <div  className="column-inner s-bottoms">
                        <div className="login-area s-bottoms ">                            
                            <div>
                                <h5>New User? Register Now</h5>                        
                            </div>    
                            {/* <img alt="Senfin" className="container-fit" src={ContainerImage}/>               */}
                        </div>
                    <Row className='mt-4'>
                        <Col md={6} xs={12}>
                            <Form.Group as={Row}>
                                <Form.Label className="c-font " column sm={4}>
                                        *Login Name
                                    </Form.Label>
                                    <Col sm={8} >
                                    <Form.Control 
                                    maxLength={16}
                                    value={Username.replace(/[^a-zA-Z0-9_]/g, "").replace(/\s+/g, '').toLowerCase()}
                                    onChange ={(e)=>setUsername(e.target.value)} className="form-h2" size="sm" type="text" placeholder="Login Name" />
                                    <p className='vali-txt'>{validator.message('Username', Username, 'required')}</p>
                                    </Col>
                                </Form.Group>
                            <Form.Group as={Row} >
                                <Form.Label className="c-font " column sm={4}>
                                    *Security Question
                                </Form.Label>
                                <Col sm={8}>
                                <Form.Select size="sm" className="form-h2 " onChange={SecurityQuestion.bind(this)} >
                                    <option value={JSON.stringify("")}>- SELECT -</option>
                                    {Questions.map((ListValue,index)=>{
                                    return( <option value={JSON.stringify(ListValue.code)}>{ListValue.name}</option>)
                                    })}
                                    
                                </Form.Select>
                                <p className='vali-txt'>{validator.message('Question', SecurityQues, 'required')}</p>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} >
                                <Form.Label className="c-font  " column sm={4}>
                                *Security Answer
                                </Form.Label>
                                <Col sm={8} >
                                <Form.Control onChange ={(e)=>setSecurityAns(e.target.value)} size="sm" className="form-h2" type="" placeholder="Security Answer" />
                                <p className='vali-txt'>{validator.message('Question', SecurityAns, 'required')}</p>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} >
                                <Form.Label className="c-font " column sm={4}>
                                    *Identification Type
                                </Form.Label>
                                <Col sm={8}>
                                <Form.Select size="sm" className="form-h2 " value={idType} onChange={handleIDType} >
                                    <option value="">- SELECT -</option>
                                    <option value="NIC">National ID No</option>
                                    <option value="PAS">Passport No</option>
                                    <option value="BRG">Business Registration No</option>
                                </Form.Select>
                                <p className='vali-txt'>{validator.message('idType', idType, 'required')}</p>
                                </Col>
                            </Form.Group>
                            {
                                idType != 'BRG'?
                                <Form.Group as={Row} >
                                    <Form.Label className="c-font" column sm={4}>
                                    *First Name
                                    </Form.Label>
                                    <Col sm={8} >
                                    <Form.Control size="sm" onChange ={(e)=>setFname(e.target.value)} className="form-h2" type="text" placeholder="First Name" />
                                    {
                                        idType == 'BRG'?
                                        <p className='vali-txt'></p>
                                        :
                                        <p className='vali-txt'>{validator.message('First name', Fname, 'required')}</p>
                                    }
                                    </Col>
                                </Form.Group>
                                :null
                            }
                            <Form.Group as={Row} >
                                <Form.Label className="c-font" column sm={4}>
                                {idType != 'BRG'?'*Last Name':'*Business Name'}
                                </Form.Label>
                                <Col sm={8} >
                                <Form.Control size="sm" onChange ={(e)=>setLname(e.target.value)} className="form-h2" type="text" placeholder={idType != 'BRG'?'Last Name':'Business Name'}/>
                                <p className='vali-txt'>{validator.message((idType != 'BRG'?'Last Name':'Business Name'), Lname, 'required')}</p>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}  >
                                <Form.Label className="c-font" column sm={4}>
                                *Identification No
                                </Form.Label>
                                <Col sm={8} >
                                <Form.Control onChange ={(e)=>setNationalID(e.target.value)} size="sm" className="form-h2" type="text" placeholder={idType == "NIC"?'National ID No':(idType == "PAS"?'Passport No':'Business Registration No')} />
                                <p className='vali-txt'>{validator.message('Identification No', NationalID, 'required')}</p>
                                </Col>
                            </Form.Group>

                        </Col>
                        <Col md={6} xs={12}>
                            <Form.Group as={Row}>
                                <Form.Label className="c-font " column sm={4}>
                                *Password
                                </Form.Label>
                                <Col sm={8} >
                                <div className="pass-wrapper">
                                <Form.Control maxLength={8} size="sm" onChange ={(e)=>setPassWord(e.target.value)} className="form-h2" type={ShowPassword?"text":"password"}   placeholder="Password" />
                                <ieshow className="ieshow" onClick={()=>{hsetShowPassword()}}>{eye}</ieshow>
                                </div>
                                <span className='highlight-txt' style={{color:'rgb(183 174 169)'}}>Please note that Passwords are case sensitive.<br/>
                                    (password should contain 8 characters with at least 1 digit and 1 letter)</span>
                                <p className='vali-txt'>{validator.message('password', PassWord, 'required')}</p>
                                </Col>

                            </Form.Group>
                            <Form.Group as={Row}>
                                <Form.Label className="c-font " column sm={4}>
                                *Re-type password
                                </Form.Label>
                                <Col sm={8} >
                                <div className="pass-wrapper">
                                <Form.Control
                                onPaste={(e)=>{
                                    e.preventDefault()
                                    return false;
                                }}
                                onCopy={(e)=>{
                                    e.preventDefault()
                                    return false;
                                }}
                                maxLength={8} size="sm" onChange ={(e)=>setReTypePassWord(e.target.value)}  className="form-h2" type={ShowPassword2?"text":"password"} placeholder="Re-type password" />
                                <ieshow className="ieshow" onClick={()=>{hsetShowPassword2()}}>{eye}</ieshow>
                                </div>
                                <p className='vali-txt'>{validator.message('Re-type password', ReTypePassWord, 'required')}</p>
                                </Col>
                            </Form.Group>
                
                            <Form.Group as={Row} >
                                <Form.Label className="c-font" column sm={4}>
                                *Address1
                                </Form.Label>
                                <Col sm={8} >
                                <Form.Control size="sm" onChange ={(e)=>setAddressLine1(e.target.value)} className="form-h2" type="text" placeholder="Address1" />
                                <p className='vali-txt'>{validator.message('AddressLine1', AddressLine1, 'required')}</p>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}  >
                                <Form.Label className="c-font" column sm={4}>
                                *Address2
                                </Form.Label>
                                <Col sm={8} >
                                <Form.Control size="sm" onChange ={(e)=>setAddressLine2(e.target.value)} className="form-h2" type="text" placeholder="Address2" />
                                <p className='vali-txt'>{validator.message('AddressLine2', AddressLine2, 'required')}</p>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} >
                                <Form.Label className="c-font" column sm={4}>
                                Address3
                                </Form.Label>
                                <Col sm={8} >
                                <Form.Control size="sm" onChange ={(e)=>setAddressLine3(e.target.value)} className="form-h2" type="text" placeholder="Address3" />
                                
                                </Col>
                            </Form.Group>

                        </Col>
                        <Form.Group as={Row} className="mt-3">
                                <Col sm={12} className="c-space-between"> 
                                <Button 
                                    className="btn-login s-bottoms"
                                    variant="primary" size="sm"
                                    onClick={() => navigate('/')} >
                                    BACK
                                </Button>
                                    <Button onClick={()=>SendOTP()}                                    
                                    className="btn-login s-bottoms" size="sm"
                                     variant="primary" type="submit">
                                    REGISTER
                                    </Button>
                                </Col>                       
                        </Form.Group>   
                    </Row>
{/*            
                    <div  className="column-inner s-bottoms">
                        <div className="login-area s-bottoms ">                            
                            <div>
                                <h5>New User? Register Now</h5>                        
                            </div>    
                                                
                        </div>
                    <Form id="fill">
                  
                       
                                      
                    </Form>
                        */}
                    </div>
                    </div>
                    </Col>
                    </Row>
                </Row>
                </Container>
            </Container>
            )    
}
export default CreateNewUser;